var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('OldModal',{attrs:{"is-loading":false,"title":_vm.$t('unsupported-browser')},on:{"close":_vm.close}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_vm._v(_vm._s(_vm.$t('you-are-using-an-unsupported-browser')))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }